import {
  ONBOARD_TENANT_REQUEST,
  ONBOARD_TENANT_SUCCESS,
  ONBOARD_TENANT_FAILURE,
  RESET_ONBOARD_TENANT_SUCCESS,
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,     // ✅ full success/failure response object (if available)
  error: null,    // ✅ can be string OR object
  success: false, // boolean only
};

const onboardTenantReducer = (state = initialState, action) => {
  switch (action.type) {
    case ONBOARD_TENANT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
        data: null, // ✅ clear previous response
      };

    case ONBOARD_TENANT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        data: action.payload, // ✅ full backend response preserved
      };

    case ONBOARD_TENANT_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload, // ✅ may be object
        data: typeof action.payload === 'object' ? action.payload : null, // ✅ preserve partial backend payload
      };

    case RESET_ONBOARD_TENANT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: false,
        data: null, // ✅ reset parsed response too
      };

    default:
      return state;
  }
};

export default onboardTenantReducer;